import { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@upmc/ims.component-library';
import * as actions from '../../../../store/apps/actions';
import { Actions } from '../../../UI/MDC/Card/Card';
import Icon from '../../../UI/MDC/Icon/Icon';
import Tooltip from '../../../UI/Tooltip/tooltip';
import DeleteModal from '../../../UI/Modal/DeleteModal';

class DeleteSelection extends Component {
	constructor(props) {
		super();
		this.state = {
			currentChoice: null,
			showModal: false,
		};

		this.onDeleteHandler = this.onDeleteHandler.bind(this);
		this.showModalHandler = this.showModalHandler.bind(this);
		this.hideModalHandler = this.hideModalHandler.bind(this);
	}

	onDeleteHandler(event) {
		if (this.props.isAnnualReviewActionFlow) {
			this.props.removeAppSync({
				index: this.props.activeIndex,
			});
		} else {
			this.showModalHandler();
		}
	}

	showModalHandler() {
		this.setState({ showModal: true });
	}

	hideModalHandler() {
		this.setState({ showModal: false });
	}

	onCloseHandler = reason => {
		this.props.removeApp({
			index: this.props.activeIndex,
			appId: this.props.allForms[this.props.activeIndex].id,
			trackingNumber: this.props.trackingNumber,
		});
	};

	render() {
		let modal = null;
		if (this.state.showModal) {
			modal = (
				<DeleteModal
					isOpen={this.state.showModal}
					name={this.props.allForms[this.props.activeIndex].name}
					onAccept={() => this.onCloseHandler()}
					onClose={() => this.hideModalHandler()}
					onDismiss={() => this.hideModalHandler()}
				/>
			);
		}

		let isTooltipDisabled = false;
		let tooltipMessage = null;

		const id = this.props.allForms[this.props.activeIndex]
			? this.props.allForms[this.props.activeIndex].id
			: null;
		if (
			this.props.appDependencies &&
			this.props.appDependencies[id] &&
			this.props.appDependencies[id].length > 0
		) {
			let dependencyParentName = '';
			let dependencyChildNames = [];
			if (
				this.props.allForms[this.props.activeIndex] &&
				Object.keys(this.props.appDependencies).includes(
					this.props.allForms[this.props.activeIndex].id + ''
				)
			) {
				const currentApp = this.props.allForms[this.props.activeIndex];
				const appDependency = this.props.appDependencies[id];
				dependencyParentName = currentApp.name;
				appDependency.forEach(dep => {
					Object.keys(this.props.allForms).forEach(form => {
						if (this.props.allForms[form].id === dep) {
							dependencyChildNames.push(
								this.props.allForms[form].name
							);
						}
					});
				});
			}
			if (dependencyChildNames.length > 0) {
				isTooltipDisabled = true;
			}
			tooltipMessage = isTooltipDisabled
				? dependencyParentName +
				  ' required by ' +
				  dependencyChildNames.join(', ')
				: null;
		}

		return (
			<div>
				<Tooltip message={tooltipMessage}>
					<Actions>
						{!this.props.isAnnualReviewActionFlow ? (
							<Button
								endIcon={<Icon icon='delete' />}
								id={`app-${this.props.appId}__remove`}
								onClick={event => this.onDeleteHandler(event)}
								disabled={isTooltipDisabled}
							>
								Remove
							</Button>
						) : null}
					</Actions>
				</Tooltip>
				{modal}
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return {
		//add action creators
		removeApp: payload => dispatch(actions.removeApp(payload)),
		removeAppSync: payload => dispatch(actions.removeAppSync(payload)),
	};
};

const mapStateToProps = state => {
	const searchParams = new URLSearchParams(
		window.location.search || ''
	);
	return {
		allForms: state.apps.allForms,
		activeIndex: state.apps.activeIndex,
		trackingNumber: state.apps.trackingNumber,
		appDependencies: state.apps.appDependencies,
		isAnnualReviewActionFlow:
			searchParams.get('uarSource') === 'annualReview',
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSelection);
